






































import { Vue, Component, Model, Prop } from 'vue-property-decorator';

import BaseTimepicker from './BaseTimepicker.vue';

@Component({
    name: 'TimepickerPopup',
    components: {
        BaseTimepicker,
    },
    inheritAttrs: false,
})
export default class TimepickerPopup extends Vue {
    @Model('update:time', { required: true }) readonly time!: string
    @Prop({ default: '00:00' }) readonly placeholder!: string
    @Prop({ default: 'right' }) readonly alignment!: 'left' | 'right'
    @Prop({ default: '' }) readonly activatorClass!: string
    @Prop({ default: false }) readonly disabled!: boolean
    
    menu = false

    get timeModel() {
        return this.time
    }

    set timeModel(time) {
        this.$emit('update:time', time)
    }

    get left() {
        return this.alignment === 'left';
    }

    get right() {
        return this.alignment === 'right';
    }

    closeMenu() {
        this.menu = false;
    }
}
